const state = {
  loader: {
    loading: false
  }
}

const actions = {
  setLoader ({commit}, loader) {
    commit('setLoader', loader)
  }
}

const mutations = {
  setLoader (state, loader) {
    state.loader.loading = loader.loading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
